import { render, staticRenderFns } from "./OssMultiUpload.vue?vue&type=template&id=3aec4f5f&scoped=true"
import script from "./OssMultiUpload.vue?vue&type=script&lang=js"
export * from "./OssMultiUpload.vue?vue&type=script&lang=js"
import style0 from "./OssMultiUpload.vue?vue&type=style&index=0&id=3aec4f5f&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aec4f5f",
  null
  
)

export default component.exports